export enum Nationality {
  French = 'Française',
  European = 'Européenne',
  NotEuropean = 'Non européenne',
  IodasRecovery = 'Reprise IODAS',
  AbcRecovery = 'Reprise ABC',
}

export const labelsByNationality: Map<Nationality, string> = new Map<Nationality, string>(
  Object.keys(Nationality).map((x: string) => [x, Nationality[x]] as [Nationality, string]),
);
